app.controller('OrderHistorySubmittedEntryController', ['$rootScope', '$scope', '$http', '$state', '$stateParams', function ($rootScope, $scope, $http, $state, $stateParams) {

    $scope.order_id = $stateParams.order_id;
    $scope.waiting_for_data = !!$scope.order_id;

    $scope.visible_order = null;
    $scope.consignment_data = null;

    if ($scope.waiting_for_data) {
        $rootScope.service.account.requireMinimumData(function () {
            $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {

                const visibleOrder = success && $rootScope.service.order_helper.isOrderSubmitted(order) ? order : null;

                if (visibleOrder && visibleOrder.status == "GONE") {
                    $rootScope.service.order.requestConsignments($scope.order_id, function (success, data) {
                        $scope.waiting_for_data = false;
                        $scope.visible_order = visibleOrder;
                        $scope.consignment_data = data[0];
                    });
                } else {
                    $scope.waiting_for_data = false;
                    $scope.visible_order = visibleOrder;
                }

            })
        });
    }

}]);